import { common } from './common-sidecar'

export function sliceRawFrame(
  source: string,
  x: number,
  y: number,
  w: number,
  h: number,
) {
  let scene = common.getPhaserScene()
  let f = new Phaser.Textures.Frame(
    scene.game.textures.get(source),
    `sr-${y}-${x}-${h}-${w}`,
    0,
    x,
    y,
    w,
    h,
  )
  return f
}
